import SearchListPage from './src/index.vue'

SearchListPage.install = (Vue) => {
  Vue.component(SearchListPage.name, SearchListPage)
}

export default SearchListPage
